/**
 * @typedef {string} Timestamp
 *
 * @typedef {{
 *   id: string,
 *   name: string,
 *   colour: string,
 *   createdAt: Timestamp,
 *   updatedAt: Timestamp,
 * }} Label
 *
 */

import v3Generic from './v3-generic';
var _v3Generic = v3Generic('labels', 'sql'),
  search = _v3Generic.search,
  single = _v3Generic.single;
export default {
  /**
   *
   * @param {Object} [optional] $axios
   * @param {import('./v3-generic').SqlSearchOptions} options
   *
   * @returns {Promise<{data: Label[]}>} Unresolved Promise from the API.
   */
  search: search,
  /**
   * Fetch a singular taxonomy by ID
   *
   * @param {Object} [optional] $axios Axios instance.
   * @param {String} id
   *
   * @returns {Promise<Label>} Unresolved Promise from the API.
   */
  single: single
};